import { ReactElement, useMemo } from 'react';
import EditableCell, { EditableCellProps } from '../EditableCell';
import { getClasses } from '@/utils';
import TimeInput from '@/common/TimeInput';

export type EditableTimeCellProps = Omit<EditableCellProps, 'as' | 'value'> & {
  value: string;
};

const EditableTimeCell = ({ ...props }: EditableTimeCellProps): ReactElement => {
  const CustomTimeInput = useMemo(
    () =>
      ({ value, onChange }) => <TimeInput value={value} onBlur={(val) => onChange(val)} />,
    []
  );
  return <EditableCell as={CustomTimeInput} {...props} className={getClasses('EditableTimeCell', props.className)} />;
};
export default EditableTimeCell;
